import { useAdminContext } from "@aix/ui"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useEffect } from "react"
import { AdminBenchmarks } from "~/components/Admin/AdminBenchmarks/AdminBenchmarks"
import CustomHead from "~/components/SEOHead/CustomHead"
import { SuperAdminLayout } from "~/layouts/SuperAdminLayout"
import { api } from "~/utils/api"

function AdminBenchmarksPage() {
  const { isAdmin } = useAdminContext()
  const navigate = useNavigate()
  const ctx = api.useContext()

  const user = ctx.users.getUserWithTeam.getData()

  useEffect(() => {
    if (!isAdmin) {
      void navigate({ to: "/home" })
    }
  }, [user?.id, isAdmin, navigate])

  return (
    <>
      <CustomHead title="Model Benchmarks | Admin" />
      <AdminBenchmarks />
    </>
  )
}

function AdminBenchmarksPageWrapper() {
  return (
    <SuperAdminLayout>
      <AdminBenchmarksPage />
    </SuperAdminLayout>
  )
}

export const Route = createFileRoute("/admin/benchmarks")({
  component: AdminBenchmarksPageWrapper,
})
